import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { catalogGroups, emit, text } from "../helpers";

var root = $.from_html(`<span class="slex-catalog-count"> </span>`);
var root_1 = $.from_html(`<div class="slex-catalog-header"><span class="slex-catalog-label"> </span> <!></div>`);
var root_2 = $.from_html(`<span class="slex-catalog-status"> </span>`);
var root_3 = $.from_html(`<a><span class="slex-catalog-title"> </span> <!></a>`);
var root_4 = $.from_html(`<section class="slex-catalog-section"><div class="slex-catalog-group"><span> </span> <span class="slex-catalog-group-count"> </span></div> <div class="slex-catalog-section-list"></div></section>`);
var root_5 = $.from_html(`<nav class="slex-catalog"><!> <div class="slex-catalog-list"></div></nav>`);

export default function Catalog($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var nav = root_5();
	var node = $.child(nav);

	{
		var consequent_1 = ($$anchor) => {
			var div = root_1();
			var span = $.child(div);
			var text_1 = $.child(span, true);

			$.reset(span);

			var node_1 = $.sibling(span, 2);

			{
				var consequent = ($$anchor) => {
					var span_1 = root();
					var text_2 = $.child(span_1, true);

					$.reset(span_1);
					$.template_effect(($0) => $.set_text(text_2, $0), [() => text($.get(p).countLabel)]);
					$.append($$anchor, span_1);
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).countLabel) $$render(consequent);
				});
			}

			$.reset(div);
			$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label, "Catalog")]);
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($.get(p).hideHeader !== true) $$render(consequent_1);
		});
	}

	var div_1 = $.sibling(node, 2);

	$.each(div_1, 21, () => catalogGroups($.get(p).items), $.index, ($$anchor, group) => {
		var section = root_4();
		var div_2 = $.child(section);
		var span_2 = $.child(div_2);
		var text_3 = $.child(span_2, true);

		$.reset(span_2);

		var span_3 = $.sibling(span_2, 2);
		var text_4 = $.child(span_3, true);

		$.reset(span_3);
		$.reset(div_2);

		var div_3 = $.sibling(div_2, 2);

		$.each(div_3, 21, () => $.get(group).items, $.index, ($$anchor, item) => {
			const id = $.derived(() => text($.get(item).id ?? $.get(item).slug));
			const href = $.derived(() => text($.get(item).href, `/components/${encodeURIComponent($.get(id))}`));
			const selected = $.derived(() => $.get(p).active === $.get(id) || $.get(p).active === $.get(href));
			var a = root_3();
			let classes;
			var span_4 = $.child(a);
			var text_5 = $.child(span_4, true);

			$.reset(span_4);

			var node_2 = $.sibling(span_4, 2);

			{
				var consequent_2 = ($$anchor) => {
					var span_5 = root_2();
					var text_6 = $.child(span_5, true);

					$.reset(span_5);
					$.template_effect(($0) => $.set_text(text_6, $0), [() => text($.get(item).status)]);
					$.append($$anchor, span_5);
				};

				$.if(node_2, ($$render) => {
					if ($.get(item).status) $$render(consequent_2);
				});
			}

			$.reset(a);

			$.template_effect(
				($0, $1) => {
					classes = $.set_class(a, 1, 'slex-catalog-item', null, classes, { 'slex-catalog-item--active': $.get(selected) });
					$.set_attribute(a, 'href', $.get(href));
					$.set_attribute(a, 'aria-current', $.get(selected) ? "page" : undefined);
					$.set_attribute(a, 'title', $0);
					$.set_text(text_5, $1);
				},
				[
					() => text($.get(item).description ?? $.get(item).summary ?? $.get(item).title),
					() => text($.get(item).title ?? $.get(id))
				]
			);

			$.delegated('click', a, (event) => {
				if ($.get(p).preventDefault === true) event.preventDefault();

				emit($$props.ctx, "select", {
					type: "select",
					target: $$props.ctx.id,
					id: $.get(id),
					href: $.get(href),
					item: $.get(item),
					native: event
				});
			});

			$.append($$anchor, a);
		});

		$.reset(div_3);
		$.reset(section);

		$.template_effect(() => {
			$.set_attribute(section, 'aria-label', $.get(group).label);
			$.set_text(text_3, $.get(group).label);
			$.set_text(text_4, $.get(group).items.length);
		});

		$.append($$anchor, section);
	});

	$.reset(div_1);
	$.reset(nav);
	$.template_effect(($0) => $.set_attribute(nav, 'aria-label', $0), [() => text($.get(p).label, "Catalog")]);
	$.append($$anchor, nav);
	$.pop();
}

$.delegate(['click']);